import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ReceiptIcon from '@material-ui/icons/Receipt';
// Components
import PurchaseOrderReceiptTable from "./PurchaseOrderReceiptTable"; //reused table component

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import MessageBox from "../../components/MessageBox/MessageBox";
import AlertDialog from "../../components/AlertDialog/AlertDialog";
import ConfirmDialog from "./ConfirmDialog"
//cookies
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import LoadingModal from "../../components/Modal/LoadingModal";


const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	  disabled: {},
});

const PurchaseOrderReceiptForm = () => {
	const { pono, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState([]);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table
	const [itemsToConvert, setItemsToConvert] = useState([]); //data to convert to PO Receipt

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(false);

	//messages, button text for alert dialog component
	const [messages, setMessages] = useState({
		title: "Are you sure you want to convert this PO to PO Receipt?",
		description: "NOTE: Once PO has been converted to PO Receipt, all undelivered inventories will automatically be cancelled.",
	});
	const [showModal, setShowModal] = useState(false);
	const [openConfirm, setOpenConfirm] = useState(false);

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);
	const x = 0;

	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	const data = async () => {
		const po_details = await axios.get(process.env.REACT_APP_API_URL+'po_receipt_form', {
			params:{
				pono: pono,
				jc_u_idno: branchidno
			}
		}).then(function (response) {
			setItems(response.data.data[1].item_info);
			setSupplierInfo(response.data.data[0].supplier_info);
			setShipTotal(response.data.data[0].supplier_info.shipping);
			setWarehouse(response.data.data[0].supplier_info.warehouse_id);
			setItemsToConvert(response.data.data[2].items_to_convert);
		}).catch((error)=>{
			// console.log(error.message);
		});

	};	

	//return a Y-m-d date string
	const formatYmd = date => date.toISOString().slice(0, 10);

	const convert_po_to_receipt = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		formData.append("item_array", JSON.stringify(itemsToConvert));
		formData.append("jc_uname", get_cookies('username'));
		formData.append("jc_u_idno", branchidno);
		formData.append("pono", pono);
		formData.append("supplier_id", supplierInfo.supplier_id);
		formData.append("warehouse", supplierInfo.warehouse_id);
		formData.append("tran_date", formatYmd(new Date())); //Y-m-d of date now
	  
		await axios.post(process.env.REACT_APP_API_URL+'conversion_to_po_receipt', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("PO Converted to Receipt");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/purchases/purchases-order-receipt');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal
				// console.log(error);
				//alert("Po bad / show red modal here");
	  		});
	}

	return (
		<>
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-receipt"}><h2 style={{color:"black"}}>Purchase Order Receipt</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Purchase Order Receipt #{pono}</h2>
				{/* <h2>supplier id: {supid} - delivery_date: {delivery_date}</h2> test if param values were passed*/}
			</div>
			<div className="page-container">
				{/* <AlertDialog messages={messages}/> */}
				<LoadingModal showModal={showModal}/>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
								{supplierInfo.purchase_from || "Purchased Order Receipt Form"}
								</div>
								<div className={classes.title}>
									{supplierInfo.title || "Purchased From"}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Date of Delivery: 
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.date_of_delivery || "Date of delivery"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Deliver To: 
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.purchase_from || "Purchased From"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.mode_of_payment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Contact Number:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.contactno || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderReceiptTable items={items} setItems={setItems}/>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
				{get_cookies('can_process') == 1 ?
					<ColorButton disabled={btnDisabled} variant="contained" color="primary" onClick={() => setOpenConfirm(true)}
					 classes={{
						root: classes.root, 
							disabled: classes.disabled}}>
					Convert to PO Receipt
					</ColorButton>
					:null}
				</div>
			</div>
		</div>
		{openConfirm && <ConfirmDialog openConfirm={openConfirm} setOpenConfirm={setOpenConfirm} messages={messages} convert_po_to_receipt={convert_po_to_receipt} />}
		</>
	);
};

export default PurchaseOrderReceiptForm;
